import { InboxConversationListItemDto } from '../types/conversation'
import { InboxConversationListItemDtoNew } from '../types/conversation-new'

// TO DO: add missing types when available
const transformInboxConversationListItemDtoNew = (
  conversationListItem: InboxConversationListItemDtoNew,
): InboxConversationListItemDto => ({
  id: conversationListItem.id,
  last_message_id: conversationListItem.last_message.id || null,
  description: conversationListItem.last_message.data.content,
  item_count: conversationListItem.data.inventory_items.length,
  item_photos: [],
  opposite_user: {
    id: conversationListItem.data.opposite_user.id,
    badge: null,
    login: conversationListItem.data.opposite_user.login_name,
    photo: null,
  },
  unread: conversationListItem.is_unread_by_current_user,
  updated_at: conversationListItem.created_at,
})

export const transformInboxConversationListItemDtosNew = (
  conversationListItems: Array<InboxConversationListItemDtoNew>,
): Array<InboxConversationListItemDto> =>
  conversationListItems.map(transformInboxConversationListItemDtoNew)
